<div
  class="grid-footer-overlay"
  *ngIf="showPageSizeSelector || (showSelectedCount && selectedCount > 0)"
>
  <div class="page-size-container" *ngIf="showPageSizeSelector">
    <label class="page-size-label" [attr.for]="pageSizeSelectId">Rows Per Page</label>
    <select
      [attr.id]="pageSizeSelectId"
      class="page-size-select"
      aria-label="Rows Per Page"
      (change)="onPageSizeChange($event)"
    >
      <option
        *ngFor="let size of pageSizeOptions"
        [value]="size"
        [selected]="size === pageSize"
      >{{ size }}</option>
    </select>
  </div>
  <div
    class="selected-count-container"
    *ngIf="showSelectedCount && selectedCount > 0"
    [class.locked]="locked"
    [style.background-color]="footerBgColor || 'rgba(255, 255, 255, 0.95)'"
  >
    <span class="selected-text">
      {{ selectedCount }} {{ selectedCount === 1 ? itemLabel : itemLabel + 's' }} selected
      <mat-icon
        *ngIf="showAcrossPagesHint"
        class="across-pages-icon"
        matTooltip="Selection spans multiple pages"
        aria-label="Selection spans multiple pages"
      >info_outline</mat-icon>
    </span>
    <span class="separator">|</span>
    <span
      class="show-selected-link"
      [attr.aria-disabled]="locked ? true : null"
      [attr.tabindex]="locked ? -1 : 0"
      (click)="onShowSelectedOnly()"
    >
      {{ showingSelectedOnly ? 'Show All' : 'Show Selected Only' }}
    </span>
    <span class="separator">|</span>
    <span
      class="deselect-link"
      [attr.aria-disabled]="locked ? true : null"
      [attr.tabindex]="locked ? -1 : 0"
      (click)="onDeselect()"
    >Clear selection</span>
  </div>
</div>
